import axiosWithToken from '@/api/axios'
import { adminBaseUrl } from '@/store'
import { postMethodConfig } from '@/api/axios'

const state = () => ({
  links: [],
  isLoading: false
})

const getters = {
  links: (state) => state.links,
  isLoading: (state) => state.isLoading
}

const mutations = {
  SET_LINKS(state, payload) {
    state.links = payload
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  }
}

const actions = {
  fetchLinks({ commit, dispatch }, { vm }) {
    commit('SET_LOADING', true)
    axiosWithToken
      .get(vm.apiUrl)
      .then((res) => {
        commit('SET_LINKS', res.data.message)
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        commit('SET_LOADING', false)
      })
  },
  createLink({ dispatch }, { payload, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    vm.isLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/homepage-link`, data, postMethodConfig)
      .then(() => {
        vm.$router.push('/admin/links')
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        vm.isLoading = false
      })
  },
  deleteCategory(_context, { id, vm }) {
    axiosWithToken
      .delete(`${adminBaseUrl}/homepage-link/${id}`)
      .then(() => {
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
  },
  fetchCategory(_context, { id, vm }) {
    vm.ctLoading = true
    axiosWithToken
      .get(`${adminBaseUrl}/homepage-link/${id}`)
      .then((res) => {
        const message = res.data.message
        vm.imageEnUrl = message.image_en
        vm.imageRuUrl = message.image_ru
        vm.editForm.link = message.link
        vm.editForm.active = message.active == '1' ? true : false
        vm.editForm.categoryId = message.category_id
        vm.editForm.mobile = message.mobile == '1' ? true : false
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.ctLoading = false
      })
  },
  updateCategory(_context, { payload, id, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    data.append('_method', 'PUT')

    vm.ctLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/homepage-link/${id}`, data, postMethodConfig)
      .then(() => {
        vm.$refs['editCategoryModal'].hide()
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.ctLoading = false
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
